import React from "react";
import "../css/delivery.scss";

function Delivery() {
  return (
    <main className="delivery policy-page">
      <div className="policy-container">
        <p className="policy-updated">Last updated: 7 September 2026</p>
        <h1 className="policy-title">Delivery &amp; Shipping</h1>
        <div className="policy-content">
          <div className="policy-callout"><strong>Online ordering is not currently enabled.</strong> No delivery charge is calculated and no shipment is created through this preview site.</div>
          <h2>Before ordering opens</h2>
          <p>We will publish the available destinations, carriers, prices, estimated delivery windows, tracking process and customs information before online orders are accepted.</p>
          <h2>Availability enquiries</h2>
          <p>You may email <a href="mailto:track@uightparcel.shop?subject=Delivery%20and%20availability">track@uightparcel.shop</a> to ask about future availability. An enquiry is not an order and does not require payment information.</p>
          <h2>International duties</h2>
          <p>Where international ordering becomes available, applicable duties, taxes and import charges will be disclosed where reasonably possible before purchase. Responsibility may vary by destination and will be stated in the final sales terms.</p>
        </div>
      </div>
    </main>
  );
}

export default Delivery;
